module.exports = __webpack_public_path__ + "static/img/14.e9cc8e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/sp/14.png
// module id = qXvE
// module chunks = 0